<template>
  <b-modal
    v-model="modalShow"
    size="xl"
    scrollable
    title="Order Details"
    @hidden="$emit('modal-closed')"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>

    <b-alert
      variant="danger"
      :show="loadingError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ loadingError }}
        </p>
      </div>
    </b-alert>

    <div v-if="!loading && !loadingError">
      <b-table-simple
        responsive
        class="compact-table"
      >
        <b-tbody>
          <b-tr>
            <b-th>
              Order Number
            </b-th>
            <b-td>
              {{ data.order_number }}
            </b-td>
            <b-th>
              Marg Order ID
            </b-th>
            <b-td>
              {{ data.marg_order_id }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              Party
            </b-th>
            <b-td>
              {{ data.party__identifier }}
            </b-td>
            <b-th>
              Total Items
            </b-th>
            <b-td>
              {{ formateNumber(data.total_items) }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              Total Amount
            </b-th>
            <b-td>
              {{ formateNumber(data.total_amount) }}
            </b-td>
            <b-th>
              Status
            </b-th>
            <b-td>
              {{ data.status }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>
              Placed By
            </b-th>
            <b-td>
              {{ data.placed_by__fullname }}
            </b-td>
            <b-th>
              Created At
            </b-th>
            <b-td>
              {{ data.created_at ? formatedDate(data.created_at) : '-' }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th> Bill No </b-th>
            <b-td> {{ data.bill_info ? data.bill_info.bill.bill_no : '' }} </b-td>
            <b-th>
              Remarks
            </b-th>
            <b-td>
              {{ data.remarks }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th> Bill Amount </b-th>
            <b-td> {{ data.bill_info ? data.bill_info.bill.amount : '' }} </b-td>
            <b-th> Attachments </b-th>
            <b-td v-if="data.bill_info">
              <span
                v-for="(item, index) in data.bill_info.bill.bill_attachments"
                :key="index"
              >
                <a
                  v-if="index === data.bill_info.bill.bill_attachments.length - 1"
                  :href="item.file"
                  target="_blank"
                >
                  <span>View File {{ index+ 1 }} </span>
                </a>
              </span>
            </b-td>
            <b-td v-else />
          </b-tr>
          <b-tr>
            <b-th> Other Orders </b-th>
            <b-td
              colspan="3"
              class="other-orders-cell"
            >
              {{ otherOrderNumbers || '-' }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="order-status-wrapper">
        <div class="timeline-wrapper mt-2">
          <hr class="timeline-line">
          <b-row>
            <b-col>
              <div class="d-flex justify-content-between">
                <div class="text-center">
                  <status
                    class="timeline-status"
                    data="CREATED"
                  />
                  <b> {{ data.placed_by__fullname }}</b>
                  <div>
                    {{ data.created_at && formatedDate(data.created_at, 'DD-MM-YYYY LT') || '-' }}
                  </div>
                </div>
                <div
                  v-if="isOrderDeleted"
                  class="text-center"
                >
                  <status
                    data="DELETED"
                    class="timeline-status"
                  />
                  <div>
                    <b>&nbsp;</b>
                    <div class="mb-1">
                      {{ data.deleted_at && formatedDate(data.deleted_at, 'DD-MM-YYYY LT') || '' }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="!isOrderDeleted"
                  class="text-center"
                >
                  <status
                    data="CONFIRMED"
                    class="timeline-status"
                    :disabled="!data.bill_info || !data.bill_info.generated_at"
                  />
                  <div v-if="data.bill_info">
                    <b>{{ data.bill_info.generated_by }}</b>
                    <div class="mb-1">
                      {{ data.bill_info && formatedDate(data.bill_info.generated_at, 'DD-MM-YYYY LT') || '' }}
                    </div>
                  </div>
                  <span v-else>Pending</span>
                </div>
                <div
                  v-if="!isOrderDeleted && data.bill_info && data.bill_info.pick_up_time"
                  class="bg-white px-1"
                >
                  {{ data.bill_info.pick_up_time }}
                </div>
                <div
                  v-if="!isOrderDeleted"
                  class="text-center"
                >
                  <status
                    data="PICKED"
                    class="timeline-status"
                    :disabled="!isBillPicked"
                  />
                  <div v-if="isBillPicked">
                    <b> {{ data.bill_info.picked_by_fullname }} </b>
                    <div class="mb-1">
                      {{ data.bill_info.picked_at && formatedDate(data.bill_info.picked_at, 'DD-MM-YYYY LT') || '-' }}
                    </div>
                  </div>
                  <span v-else> Pending </span>
                </div>
                <div
                  v-if="!isOrderDeleted && data.bill_info && data.bill_info.delivery_time"
                  class="bg-white px-1"
                >
                  {{ data.bill_info.delivery_time }}
                </div>

                <div
                  v-if="!isOrderDeleted"
                  class="text-center"
                >
                  <status
                    data="DELIVERED"
                    class="timeline-status"
                    :disabled="!isBillDelivered"
                  />
                  <div v-if="isBillDelivered">
                    <b> {{ data.bill_info.delivered_by_fullname }} </b>
                    <div class="mb-1">
                      {{ data.bill_info.delivered_at && formatedDate(data.bill_info.delivered_at, 'DD-MM-YYYY LT') || '-' }}
                    </div>
                  </div>
                  <span v-else> Pending  </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div
          v-if="data.bill_info && data.status == 'DELIVERED' "
          class="mt-2"
        >
          <BillDeliveryInfo :item="data.bill_info" />
        </div>
      </div>

      <h5 class="mt-2 mb-1">
        Order Items
      </h5>

      <b-table-simple
        responsive
        hover
        small
        class="compact-table items-table"
      >
        <b-thead>
          <b-tr>
            <b-th
              v-for="field in orderItemsTableFields"
              :key="`head-${field.key}`"
            >
              {{ field.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="row in displayRows">
            <!-- Order section header -->
            <b-tr
              v-if="row.kind === 'section'"
              :key="`section-${row.key}`"
              :class="['section-row', row.section.isCurrent ? 'section-current' : 'section-other']"
            >
              <b-td :colspan="orderItemsTableFields.length">
                <div class="d-flex flex-wrap align-items-center">
                  <b-badge
                    :variant="row.section.isCurrent ? 'primary' : 'secondary'"
                    class="mr-1"
                  >
                    {{ row.section.isCurrent ? 'This Order' : 'Other Order' }}
                  </b-badge>
                  <b class="mr-1">#{{ row.section.order.order_number }}</b>
                  <span class="ml-auto">
                    <span
                      v-if="sectionWarningText(row.section)"
                      class="section-warning"
                    >
                      ⚠ {{ sectionWarningText(row.section) }}
                    </span>
                    <b-badge
                      v-else-if="!row.section.billPending"
                      variant="light-success"
                      class="ml-50"
                    >
                      All matched
                    </b-badge>
                  </span>
                </div>
              </b-td>
            </b-tr>

            <!-- Extra invoice items header -->
            <b-tr
              v-else-if="row.kind === 'extra-header'"
              :key="`extra-header-${row.key}`"
              class="section-row section-extra"
            >
              <b-td :colspan="orderItemsTableFields.length">
                <div class="d-flex flex-wrap align-items-center">
                  <b-badge
                    variant="warning"
                    class="mr-1"
                  >
                    Extra Invoice Items
                  </b-badge>
                </div>
              </b-td>
            </b-tr>

            <!-- Item row -->
            <b-tr
              v-else
              :key="`item-${row.key}`"
            >
              <b-td
                v-for="field in orderItemsTableFields"
                :key="`${row.key}-${field.key}`"
              >
                <template v-if="field.key === 'name'">
                  <span :style="{ color: row.item.nameColor }">{{ row.item.name }}</span>
                  <b-badge
                    v-if="row.item.isExtra"
                    variant="light-primary"
                    class="ml-50"
                  >
                    Extra
                  </b-badge>
                </template>
                <template v-else-if="field.key === 'qty'">
                  {{ row.item.isExtra ? '-' : formateNumber(row.item.qty) }}
                </template>
                <template v-else-if="field.key === 'free'">
                  {{ row.item.isExtra ? '-' : formateNumber(row.item.free) }}
                </template>
                <template v-else-if="field.key === 'billed_qty'">
                  <span :style="{ color: row.item.qtyColor }">{{ row.item.billedQty || '-' }}</span>
                </template>
                <template v-else-if="field.key === 'mrp'">
                  {{ formateNumber(row.item.mrp) }}
                </template>
                <template v-else-if="field.key === 'rate'">
                  {{ formateNumber(row.item.rate) }}
                </template>
                <template v-else-if="field.key === 'lot'">
                  {{ !row.item.lot || row.item.lot == "0 + 0" ? '' : row.item.lot }}
                </template>
                <template v-else-if="field.key === 'bonus'">
                  <span
                    v-if="row.item.special_bonus && row.item.spl_bonus_opted"
                    class="ml-1 text-success"
                  >
                    ✓
                  </span>
                  <span
                    v-else-if="row.item.special_bonus"
                    class="ml-1 text-danger"
                  >
                    X
                  </span>
                </template>
                <template v-else>
                  {{ row.item[field.key] }}
                </template>
              </b-td>
            </b-tr>
          </template>
          <b-tr v-if="!displayRows.length">
            <b-td
              :colspan="orderItemsTableFields.length"
              class="text-center text-muted"
            >
              No items found
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex align-items-center">
        <small
          v-if="data.pdf_downloaded_at"
          class="text-warning"
        >
          {{ getPdfDownloadTooltip(data) }}
        </small>
        <b-button
          variant="outline-primary"
          class="ml-auto mr-1"
          :disabled="loading || !!loadingError || downloadingPdf"
          @click="downloadPdf"
        >
          Download PDF
        </b-button>
        <b-button
          variant="secondary"
          @click="modalShow=false"
        >
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BButton, BAlert, BSpinner, BTableSimple, BThead, BTbody, BTd, BTr, BTh,
  BRow,
  BCol,
  BBadge,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import Status from '@/components/Delivery/DeliveryStatus/Status.vue'
import formatMixin from '@/mixins/formatMixin'
import orderPdfMixin from '@/mixins/orderPdfMixin'
import BillDeliveryInfo from '@/components/Delivery/BillDeliveryInfo.vue'

const COLOR_RED = 'red'
const COLOR_GREEN = '#21d619'
const COLOR_ORANGE = 'orange'
const COLOR_DEFAULT = '#333'
const COLOR_PURPLE = '#7367f0'

export default {
  components: {
    BButton,
    BAlert,
    BSpinner,
    BTableSimple,
    BThead,
    BTbody,
    BTd,
    BTr,
    BTh,
    Status,
    BRow,
    BCol,
    BBadge,
    BillDeliveryInfo,
  },
  mixins: [dateMixin, formatMixin, orderPdfMixin],
  props: {
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: {},
      modalShow: true,
      loadingError: null,
      loading: true,
      orderItemsTableFields: [
        { key: 'code', label: 'CODE' },
        { key: 'name', label: 'Name' },
        { key: 'company', label: 'Company' },
        { key: 'qty', label: 'QTY' },
        { key: 'free', label: 'Free' },
        { key: 'billed_qty', label: 'Billed QTY' },
        { key: 'unit', label: 'UNIT' },
        { key: 'mrp', label: 'MRP' },
        { key: 'rate', label: 'Rate' },
        { key: 'batch', label: 'Batch' },
        { key: 'lot', label: 'Lot' },
        { key: 'bonus', label: 'Bonus' },
      ],
    }
  },
  computed: {
    isOrderDeleted() {
      return this.data && this.data.status === 'DELETED'
    },
    isBillPicked() {
      return this.data && this.data.bill_info && (this.data.bill_info.picked_at || this.data.picked_by_fullname)
    },
    isBillDelivered() {
      return this.data && this.data.bill_info && (this.data.bill_info.delivered_at || this.data.delivered_by_fullname)
    },
    // Other order numbers in the same bill, comma separated (oldest first)
    otherOrderNumbers() {
      return this.getBillOrders()
        .filter(order => !order.is_current)
        .map(order => order.order_number)
        .join(', ')
    },
    matchedData() {
      return this.getMatchedItems()
    },
    extraItemsCount() {
      return this.matchedData.extraRows.length
    },
    // Flat list of rows: order headers, item rows, then extra invoice items header + rows
    displayRows() {
      const rows = []
      const { sections, extraRows } = this.matchedData

      sections.forEach(section => {
        const orderKey = section.order.id || section.order.order_number

        rows.push({ kind: 'section', key: `${orderKey}`, section })

        section.rows.forEach((item, index) => {
          rows.push({ kind: 'item', key: `${orderKey}-${item.id || index}`, item })
        })
      })

      if (extraRows.length) {
        rows.push({ kind: 'extra-header', key: 'extra', count: extraRows.length })
        extraRows.forEach((item, index) => {
          rows.push({ kind: 'item', key: `extra-${item.invoiceItemId || index}`, item })
        })
      }

      return rows
    },
  },
  created() {
    this.fetchDetails()
  },
  methods: {
    // Plain warning text for an order header, empty when everything matches.
    // The current order also shows the count of extra invoice items.
    sectionWarningText(section) {
      const parts = []
      if (section.notBilledCount) parts.push(`${section.notBilledCount} not billed`)
      if (section.shortCount) parts.push(`${section.shortCount} short`)
      if (section.excessCount) parts.push(`${section.excessCount} extra qty`)
      if (section.isCurrent && this.extraItemsCount) {
        parts.push(`${this.extraItemsCount} extra ${this.extraItemsCount === 1 ? 'item' : 'items'}`)
      }
      return parts.join(', ')
    },
    cleanInvoiceName(name) {
      // Remove trailing * or **
      return (name || '').replace(/\s*\*+\s*$/, '').trim()
    },
    cleanInvoicePack(pack) {
      // Remove leading #
      return (pack || '').replace(/^#+/, '').trim()
    },
    // Current order first, then other orders of the same bill (oldest first)
    getBillOrders() {
      const currentOrder = { ...this.data, is_current: true }
      const otherOrders = (this.data.bill_orders || [])
        .filter(order => !order.is_current && order.id !== this.data.id)
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))

      return [currentOrder, ...otherOrders]
    },
    applyRowColors(row) {
      const item = row
      let nameColor = 'blue'
      let qtyColor = COLOR_DEFAULT

      if (item.billPending) {
        qtyColor = COLOR_ORANGE
      } else if (item.billedQty === 0) {
        nameColor = COLOR_RED
        qtyColor = COLOR_RED
      } else if (item.totalOrderQty !== item.billedQty) {
        qtyColor = item.billedQty > item.totalOrderQty ? COLOR_GREEN : COLOR_RED
      }

      item.nameColor = nameColor
      item.qtyColor = qtyColor
    },
    // Not billed (red name) -> short qty (red) -> extra qty (green) -> rest
    sortByMismatch(rows) {
      const rank = row => {
        if (row.nameColor === COLOR_RED) return 0
        if (row.qtyColor === COLOR_RED) return 1
        if (row.qtyColor === COLOR_GREEN) return 2
        return 3
      }
      return [...rows].sort((a, b) => rank(a) - rank(b))
    },
    buildExtraRow(pool) {
      const invoiceItem = pool.invoice

      return {
        invoiceItemId: invoiceItem.id,
        code: '',
        name: `${pool.cleanName} ${pool.cleanPack}`.trim(),
        company: invoiceItem.company,
        qty: 0,
        free: 0,
        unit: pool.cleanPack,
        mrp: invoiceItem.mrp,
        rate: invoiceItem.rate,
        batch: invoiceItem.batch,
        lot: '',
        billedQty: pool.remaining,
        nameColor: COLOR_PURPLE,
        qtyColor: COLOR_GREEN,
        totalOrderQty: 0,
        isExtra: true,
      }
    },
    getMatchedItems() {
      const result = { sections: [], extraRows: [] }
      if (!this.data || !this.data.order_items) return result

      // Each invoice item is a "pool" of quantity that orders can take from
      const pools = (this.data.invoice_items || []).map(invoiceItem => ({
        invoice: invoiceItem,
        cleanName: this.cleanInvoiceName(invoiceItem.product),
        cleanPack: this.cleanInvoicePack(invoiceItem.pack),
        remaining: Number(invoiceItem.quantity) || 0,
        lastRow: null,
      }))

      const noBill = !this.data.bill_info

      // Step 1: give billed quantity to each order item (current order first)
      const sections = this.getBillOrders().map(order => {
        const billPending = noBill || order.status === 'CREATED'

        const rows = (order.order_items || []).map(orderItem => {
          const orderName = (orderItem.name || '').trim()
          const matches = pools.filter(pool => pool.cleanName
            && orderName.startsWith(pool.cleanName)
            && orderName.endsWith(pool.cleanPack))

          const orderQty = parseFloat(orderItem.qty) || 0
          const freeQty = parseFloat(orderItem.free) || 0
          const totalOrderQty = orderQty + freeQty

          const row = {
            ...orderItem,
            orderNumber: order.order_number,
            totalOrderQty,
            billedQty: 0,
            billPending,
          }

          let need = totalOrderQty
          matches.forEach(pool => {
            const take = Math.min(pool.remaining, need)
            if (take > 0) {
              // eslint-disable-next-line no-param-reassign
              pool.remaining -= take
              need -= take
              row.billedQty += take
            }
            // eslint-disable-next-line no-param-reassign
            pool.lastRow = row
          })

          return row
        })

        return {
          order,
          isCurrent: !!order.is_current,
          billPending,
          rows,
        }
      })

      // Step 2: leftover invoice qty -> last order item of same product, else "extra"
      const extraRows = []
      pools.forEach(pool => {
        if (pool.remaining <= 0) return
        if (pool.lastRow) {
          // eslint-disable-next-line no-param-reassign
          pool.lastRow.billedQty += pool.remaining
        } else {
          extraRows.push(this.buildExtraRow(pool))
        }
        // eslint-disable-next-line no-param-reassign
        pool.remaining = 0
      })

      // Step 3: colors, sort mismatches first, counts
      sections.forEach(section => {
        section.rows.forEach(row => this.applyRowColors(row))

        Object.assign(section, {
          rows: this.sortByMismatch(section.rows),
          notBilledCount: section.rows.filter(row => row.nameColor === COLOR_RED).length,
          shortCount: section.rows.filter(row => row.nameColor !== COLOR_RED && row.qtyColor === COLOR_RED).length,
          excessCount: section.rows.filter(row => row.qtyColor === COLOR_GREEN).length,
        })
      })

      result.sections = sections
      result.extraRows = extraRows
      return result
    },
    async downloadPdf() {
      const downloaded = await this.downloadOrdersPdf([this.data.id])
      if (!downloaded) return

      if (!this.data.pdf_downloaded_at) {
        this.data = {
          ...this.data,
          pdf_downloaded_at: new Date().toISOString(),
          pdf_downloaded_by__fullname: this.$store.getters['auth/userName'],
        }
      }
      this.$emit('pdf-downloaded', [this.data.id])
    },
    fetchDetails() {
      axios.get(`/marg/orders/${this.itemId}`)
        .then(res => {
          this.data = res.data
          this.loadingError = null
          this.loading = false
        })
        .catch(error => {
          this.loadingError = error?.response?.data?.error || 'Error fetching order details!'
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.timeline-wrapper {
    position: relative;

}
.timeline-line {
    position: absolute;
    left: 0;
    right: 0;
    top: -3px;
    width: 90%;
}

.timeline-status {
    margin-bottom: 4px;
}
.order-status-wrapper{
  margin: auto;
  max-width: 1000px;
  min-width: 800px;
}

.other-orders-cell {
  white-space: normal;
  word-break: break-word;
}

.items-table {
  .section-row td {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: 2px solid #d8d6de;
  }
  .section-current td {
    background-color: rgba(115, 103, 240, 0.12);
  }
  .section-other td {
    background-color: #f3f2f7;
  }
  .section-extra td {
    background-color: rgba(255, 159, 67, 0.15);
  }
  .section-warning {
    color: #ff9f43;
    font-weight: 600;
    font-size: 0.85rem;
  }
}
</style>
